// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"524":"app","884":"admin"}[chunkId] || chunkId) + "." + {"345":"c1a365b643e6294b5d4d","524":"152ea41579ed79256da7","532":"07eb3a702f41c583807b","595":"1abedd63127d1f1ad4f5","708":"57be1c1794147b88065a","884":"3a7ddb0280aa5a094613","912":"9e36796ef42f7363f51d","992":"f92f5888400ea957b0dc"}[chunkId] + ".js";
};